import apiN8n from "../axios/n8n";

class N8nService {
  static async getStatsAnalysis(data = null) {
    try {
      const response = await apiN8n.post(`/webhook/stats`, data);
      if (response.status < 400) {
        return { success: true, data: response.data };
      }
      return {
        success: false,
        message: "Unexpected response status",
        status: response.status,
      };
    } catch (error) {
      console.error("Error getting Analysis:", error);
      return {
        success: false,
        message: error.message,
        status: error.response?.status || 500,
      };
    }
  }
}

export default N8nService;
